import ActionBar from 'components/organisms/action-bar'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import {
  clearData,
  getActionBarItems,
  getDynamicEndpoint,
  postDynamicEndpoint,
} from 'redux/actions/data'
import { openOverlay } from 'redux/actions/ui'

const mapStateToProps = ({ auth, data, forms }) => {
  let dataProp = {}

  if (data.newCar) {
    dataProp = {
      ...data.newCar.data,
    }
  }

  if (data.carfile) {
    dataProp = {
      ...data.carfile.data,
    }
  }

  if (auth) {
    dataProp.token = auth.instanceId
  }

  return {
    data: dataProp,
    dynamicEndpoint: data.dynamicEndpoint,
    forms,
    items: data.actionBarItems && data.actionBarItems.data,
  }
}

const mapDispatchToProps = {
  clearData,
  getActionBarItems,
  getDynamicEndpoint,
  openOverlay,
  postDynamicEndpoint,
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(ActionBar))
